import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import WebinarPost from "@/pages/WebinarPost";

export const Route = createFileRoute("/zh-cn/webinars/$slug")({
  loader: ({ params }) => loadContentMeta("webinars", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/webinars/${params.slug}`, loaderData),
  component: WebinarPost,
});

